module.exports = __webpack_public_path__ + "img/weathertop-3018-10-03.da124339.jpg";